/** biome-ignore-all lint/style/noRestrictedImports: date-fns imports are allowed in @cobliteam/utils only. All other packages must import from @cobliteam/utils/date. */
import { formatDistance as formatDistanceFns, format as formatFns, formatRelative as formatRelativeFns } from 'date-fns';
import { DEFAULT_LOCALE } from './constants';
import type { DateValue } from './types';

// biome-ignore lint/performance/noBarrelFile: Main entry point for the date-fns lib
// biome-ignore lint/performance/noReExportAll: All exports are re-exported from the automatic generated files
export * from 'date-fns';

export function formatDistance(date: DateValue, baseDate: DateValue = new Date(), options?: Parameters<typeof formatDistanceFns>[2]): string {
  return formatDistanceFns(date, baseDate, {
    locale: DEFAULT_LOCALE,
    ...options,
  });
}

export function format(date: DateValue, pattern: string, options?: Parameters<typeof formatFns>[2]): string {
  return formatFns(date, pattern, {
    locale: DEFAULT_LOCALE,
    ...options,
  });
}

export function formatRelative(date: DateValue, baseDate: DateValue = new Date(), options?: Parameters<typeof formatRelativeFns>[2]): string {
  return formatRelativeFns(date, baseDate, {
    locale: DEFAULT_LOCALE,
    ...options,
  });
}
